import { SENSOR_MEASURES, WEATHER_MEASURES } from "../config/sensors.config";

const measureDefinitions = { ...WEATHER_MEASURES, ...SENSOR_MEASURES };

export const PLACEHOLDERS = {
  TOOLS: {
    DEV_EUI: "es. 70B3D57ED003334F",
    APP_EUI: "es. 1A2B3C4D5E6F7890",
    APP_KEY: "es. 1A2B3C4D5E6F78901A2B3C4D5E6F7890",
    GATEWAY_EUI: "es. AA555A0000000101",
  },
};

export const MEASURE_UNITS = {
  Pressione: "hPa",
  co2: "ppm",
  Luce: "lux",
  ...Object.fromEntries(Object.values(measureDefinitions).map(({ label, unit }) => [label, unit])),
};

export const PARAM_LABELS = Object.fromEntries(
  Object.entries(measureDefinitions).map(([key, { label }]) => [key, label]),
);

export const MEASURE_TRANSLATIONS = { ...PARAM_LABELS };

export const MEASURE_LABEL = Object.fromEntries(
  Object.entries(SENSOR_MEASURES).filter(([, { apiKey }]) => apiKey)
    .map(([key, { apiKey }]) => [key, apiKey]),
);

export const TIME_RANGES = {
  "24h": { value: 24, unit: "hours" },
  "7d": { value: 7, unit: "day" },
};

export const SENSOR_STATUS = {
  Disconnected: "Disconnesso",
  Connected: "Connesso",
};

export const FIELD_TO_PARAM = {
  moisture: "soil_moisture",
  temperature: "soil_temperature",
  soil_ec: "soil_electrical_conductivity",
};
